module.exports = __webpack_public_path__ + "static/media/ImgMBTI_SOTA.87f4aaef.png";